import { memo } from 'react';
import { useTheme } from 'styled-components';

import { Button } from '../../Controls/Button/index.tsx';
import Icons from '../../Elements/Icons/index.ts';
import { Loader } from '../../Elements/Loader/index.tsx';
import { Placeholder } from './styled.ts';
import type { FileResetHandler } from './types.ts';

export const FileStateIcon = memo(function FileStateIcon({
  error,
  isUploading,
  onReset,
  progressVisible,
  success,
  tryAnotherText,
}: {
  error?: string;
  isUploading: boolean;
  onReset?: FileResetHandler;
  progressVisible: boolean;
  success: boolean;
  tryAnotherText: string;
}) {
  const theme = useTheme();

  if (isUploading && !progressVisible) {
    return <Loader />;
  }

  if (success) {
    return <Icons.Check filled color={theme.colors.positive100} />;
  }

  if (error) {
    return (
      <>
        <Icons.Warning filled color={theme.colors.critical100} />
        <Button ghost onClick={onReset}>
          {tryAnotherText}
        </Button>
      </>
    );
  }

  return <Placeholder />;
});
